export default __webpack_public_path__ + "static/media/icons-20.1ef633d3.woff";